import React from "react";
import Link from "gatsby-link";
import {
  InstantSearch,
  Highlight,
  Configure,
  PoweredBy
} from "react-instantsearch/dom";
import {
  connectSearchBox,
  connectHits
} from "react-instantsearch/connectors";
import FontAwesomeIcon from "@fortawesome/react-fontawesome";
import farSearch from "@fortawesome/fontawesome-free-solid/faSearch";
import config from "../../../data/SiteConfig";

const Item = ({hit}) => (
  <div style={{marginTop: "10px"}}>
    <Link to={`/${hit.fields.slug}`}>
      <Highlight attribute="fields.title" hit={hit} tagName="b" />
    </Link>
  </div>
);

class CustomHits extends React.Component {
  render() {
    const {hits} = this.props;

    if (!hits) {
      return null;
    }

    return (
      <div>
        <Configure hitsPerPage={10} />
        {
          hits.length ?
            hits.map(hit => (
              <div className="navbar-item" key={hit.objectID}>
                <Item hit={hit} />
              </div>
            )) :
            (
              <div className="navbar-item">
                No results found :(
              </div>
            )
        }
        <hr className="navbar-divider" />
        <div className="navbar-item is-pulled-right">
          <PoweredBy />
        </div>
      </div>
    );
  } 
};

const ConnectedHits = connectHits(CustomHits);

class SearchBar extends React.Component {
  constructor(props) {
    super(props);
    
    this.searchInput = React.createRef();
    this.focusSearchInput = this.focusSearchInput.bind(this);
  }

  componentDidMount() {
    this.focusSearchInput();
  }

  focusSearchInput() {
    this.searchInput.current.focus();
  }

  render() {
    const {currentRefinement, refine, isScrolled, open, close, isOpen} = this.props;

    return (
      <div>
        <div className="navbar-item">
          <div className="control has-icons-left">
            <input
              className="input"
              type="text"
              placeholder="Search"
              value={currentRefinement}
              onChange={e => refine(e.target.value)}
              onFocus={open}
              onBlur={close}
              ref={this.searchInput}
            />
            <span className="icon is-small is-left">
              <FontAwesomeIcon icon={farSearch} />
            </span>
          </div>
        </div>
        <div className={`navbar-dropdown ${isScrolled ? "" : "is-boxed"}`}>
          <ConnectedHits isOpen={isOpen} />
        </div>
      </div>
    );
  }
}


const ConnectedSearchBox = connectSearchBox(SearchBar);

/* eslint react/no-multi-comp: "off" */
export default class Search extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hasFocused: false,
      isOpen: false,
    };

    this.handleFocus = this.handleFocus.bind(this);
    this.closeSearch = this.closeSearch.bind(this);
    this.openSearch = this.openSearch.bind(this);
  }

  handleFocus() {
    const {hasFocused} = this.state;
    if (!hasFocused) {
      this.setState({hasFocused: true});
    }
  }

  closeSearch() {
    this.setState({isOpen: false});
  }

  openSearch() {
    this.setState({isOpen: true});
  }

  render() {
    const {isOpen, hasFocused} = this.state;
    return (
      <div className={`navbar-item has-dropdown is-hoverable ${isOpen ? "is-active" : ""}`}>
        {
          // mounts Algolia search only on first focus
          // prevents gatsby builds from going over 30 QPS
          // due to initial search on component load
          !hasFocused ? 
            (
              <div className="navbar-item">
                <div className="control has-icons-left">
                  <input
                    className="input"
                    type="text"
                    placeholder="Search"
                    onFocus={this.handleFocus}
                  />
                  <span className="icon is-small is-left">
                    <FontAwesomeIcon icon={farSearch} />
                  </span>
                </div>
              </div>
            ) : 
            (
              <InstantSearch
                appId={config.algoliaApplicationID}
                apiKey={config.algoliaSearchOnlyAPIKey}
                indexName={config.algoliaIndexName}
              >
                <ConnectedSearchBox
                  {...this.props}
                  close={this.closeSearch}
                  open={this.openSearch}
                />
              </InstantSearch>
            )
        }
      </div>
    );
  }
};



// WEBPACK FOOTER //
// ./src/components/Search/index.jsx